import {AddressFormItemType, AddressType} from 'desktop/types/addressType';
import {ProcessedGoogleAddressItemType} from 'desktop/types/googleTypes';
import {CountriesType, StatesItemType} from 'types/locationType';

import {getAddressModifier} from '../getAddressModifier/getAddressModifier';
import {getCountriesModifier} from '../getCountriesModifier/getCountriesModifier';
import {getPostalModifier} from '../getPostalModifier/getPostalModifier';
import {getStatesModifier} from '../getStatesModifier/getStatesModifier';

type ModifierParametersType = {
    states: Array<StatesItemType>;
    countries: Array<CountriesType>;
    type: string;
    result: AddressFormItemType | AddressType;
};

/**
 * Apply some modifiers in depends of field name and returns modified values for result fields
 * @param {string} field - Received field name to determine certain modifier
 * @param {string} value - Received value to update field
 * @param {Array<StatesItemType>} states - Approved states in which we'll search received state
 * @param {Array<CountriesType>} countries - Approved countries in which we'll search received state
 * @param {string} type - Type of value which we should put in to field. Short or long notations
 * @returns {AddressType} - Returned updated address with few modified fields
 */
export const applyModifiers = (
    field: string,
    value: {[key: string]: string},
    {countries, result, states, type}: ModifierParametersType,
): AddressType => {
    switch (field) {
        case 'address': {
            return {
                address: getAddressModifier(
                    typeof result.address === 'object' ? result.address.value : result.address,
                    value[type],
                ),
            };
        }
        // Handle states completions
        case 'state': {
            return getStatesModifier(states, value as ProcessedGoogleAddressItemType);
        }
        // Handle countries completions
        case 'country': {
            return {country: getCountriesModifier(countries, value[type])};
        }
        case 'postal': {
            return {
                postal: getPostalModifier(
                    typeof result.postal === 'object' ? result.postal.value : result.postal,
                    value[type],
                ),
            };
        }
        // Handle other completions
        default: {
            return {
                [field]: {
                    error: false,
                    success: true,
                    value: value[type],
                },
            };
        }
    }
};
